import { NgClass } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  input,
  output,
  viewChild,
} from '@angular/core';
import {
  SpinnerDirective,
  UIBasicIconsType,
  UseLogoDirective,
  UseUIBasicIconDirective,
} from '../atoms';

@Component({
  selector: 'dmcom-chip',
  imports: [
    UseUIBasicIconDirective,
    NgClass,
    SpinnerDirective,
    UseLogoDirective,
  ],
  template: `
    <div
      [class.pointer-events-none]="isDisabled()"
      [class.opacity-50]="isDisabled()"
      class="
        group
        flex items-center justify-center gap-8
        rounded-full px-16 py-6
        w-fit
        max-w-full
        bg-chip-unselected-enabled
        z-20
      "
      [ngClass]="{
        'hover:bg-gradient-grayscale-gray-light': !isSelected() && !rightIcon(),
        'active:bg-gradient-grayscale-gray-light': isSelected(),
        'cursor-pointer': !rightIcon(),
        'cursor-default': rightIcon(),
      }"
      (click)="chipClicked.emit(title())"
    >
      @if (isLoading()) {
        <span class="shrink-0" dmcomSpinner></span>
      } @else {
        <img dmcomUseLogo="logo-docmagic" class="h-16" />
      }
      <span
        #titleElement
        [title]="isTruncated ? title() : ''"
        class="
        typo-caption text-grayscale-gray-darker
        truncate"
        >{{ title() }}</span
      >
      @if (rightIcon(); as rightIcon) {
        <svg
          [dmcomUseUIBasicIcon]="rightIcon"
          class="visible size-20 shrink-0"
          [ngClass]="{
            'cursor-not-allowed': isDisabled(),
            'cursor-pointer': !isDisabled(),
          }"
          (click)="rightIconClicked.emit(title())"
        ></svg>
      }
    </div>
  `,
})
export class ChipComponent implements AfterViewInit {
  public readonly title = input.required<string>();
  public readonly isDisabled = input<boolean>(false);
  public readonly isLoading = input<boolean>(false);
  public readonly isSelected = input<boolean>(false);
  public readonly rightIcon = input<UIBasicIconsType>();
  public readonly rightIconClicked = output<string>();
  public readonly chipClicked = output<string>();
  public readonly titleElement =
    viewChild.required<ElementRef<HTMLSpanElement>>('titleElement');
  public isTruncated = false;

  private readonly cdr = inject(ChangeDetectorRef);

  ngAfterViewInit() {
    // Check truncation after the view is initialized
    this.isTruncated = this.checkIfTruncated();
    this.cdr.detectChanges();
  }

  checkIfTruncated(): boolean {
    const element = this.titleElement()?.nativeElement;
    if (!element) return false;
    return element.scrollWidth > element.clientWidth;
  }
}
